import classNames from 'classnames';
import React from 'react';
import { ButtonGroup, ButtonGroupProps } from 'reactstrap';
import { Option } from 'types/Option';

interface Props extends Omit<ButtonGroupProps, 'onChange'> {
    btnSize?: boolean;
    options: Option[];
    value: Option[];
    onChange(options: Option[]): void;
    formatLabel?(current: Option): string;
}

const ButtonGroupSelector: React.FC<Props> = ({ btnSize, options, value, onChange, formatLabel = option => option.label, ...buttonGroupProps }) => {
    const toggleOption = (option: Option) => {
        if (value.find(opt => opt.value === option.value)) { // is already selected
            onChange(value.filter(opt => opt.value !== option.value))
        } else {
            onChange(value.concat(option))
        }
    }

    return (
        <ButtonGroup {...buttonGroupProps} className={classNames('w-100 flex-wrap shadow-sm', buttonGroupProps.className)}>
            {options.map(filter => {
                return <React.Fragment key={'btn-' + filter.value}>
                    <input id={filter.type + '-' + filter.value}
                        className='btn-check'
                        type='checkbox'
                        value={filter.value}
                        title={filter.label}
                        checked={!!value.find(e => e.value === filter.value && e.type === filter.type)}
                        onChange={() => toggleOption(filter)}
                    />
                    <label className={classNames('btn btn-outline-secondary p-3',
                        {
                            'size-btn': btnSize
                        })} htmlFor={filter.type + '-' + filter.value}>{formatLabel(filter)}</label>
                </React.Fragment>
            })
            }
        </ButtonGroup>
    )
}


export default ButtonGroupSelector;
